import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import ZmenaStadia from '../../../module/Admin/ZmenaStadia/ZmenaStadia';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import SuccessMessages from '../../../module/SuccessMessages';

const ZmenaStadiaPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.ADMIN_ZMENA_STADIA_FUNCTION);

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.list,
          heading: 'Legislatívne procesy',
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.admin.zmenaStadiaMaterialu.withParams(type, year, index),
          heading: 'Zmena štádia materiálu',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={(materialDetail?.stadium?.hodnota !== StadiumMaterialuEnum.PROCES_UKONCENY
            && materialDetail?.stadium?.hodnota !== StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE)}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Zmena štádia materiálu"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <ZmenaStadia material={materialDetail} />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default ZmenaStadiaPage;
